import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { SidebarContentsPinnedItems } from "./sidebar-contents-pinned-items";
import { SidebarContentsRecentNotes } from "./sidebar-contents-recent-notes";
import { SidebarContentsRecentCollections } from "./sidebar-contents-recent-collections";
import { SidebarButton } from "@/components/layout/components/sidebar/sidebar-section/sidebar-button";
import {
  AppearAnimator,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
  MDSIcon,
  MDSIconKind,
} from "@/mds";
import { EventContext } from "@/domains/metrics/context";
import { GettingStartedCardContainer } from "@/components/getting-started-card";

export interface SidebarContentsProps {
  onClick?: () => void;
}

export const SidebarContents = observer(function SidebarContents({
  onClick,
}: SidebarContentsProps) {
  const { store } = useAppStore();
  const isFavoriteItemsReady = store.favoriteItems.isReady;

  return (
    <StyledAppear visible={isFavoriteItemsReady}>
      <SidebarButton
        onClick={() => store.notes.composeNewNote({ eventContext: EventContext.GlobalActions })}
      >
        <StyledButtonIcon kind={MDSIconKind.ComposeInline} />
        <MDSText variant={MDSTextVariant.TextS} weight={MDSTextWeight.Medium}>
          Create Note
        </MDSText>
      </SidebarButton>
      <ScrollablePortion>
        <SidebarContentsPinnedItems onClick={onClick} />
        <SidebarContentsRecentNotes onClick={onClick} />
        <SidebarContentsRecentCollections onClick={onClick} />
      </ScrollablePortion>
      {store.gettingStarted.isGuideVisible && <GettingStartedCardContainer />}
    </StyledAppear>
  );
});

const ScrollablePortion = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
  overflow-y: auto;
  min-height: 0;
  height: 100%;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
ScrollablePortion.displayName = "ScrollablePortion";

const StyledAppear = styled(AppearAnimator)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
  flex: 1;
  overflow: hidden;
`;
StyledAppear.displayName = "StyledAppear";

const StyledButtonIcon = styled(MDSIcon)`
  .mds-icon {
    font-size: 11px;
    height: 11px;
    width: 11px;
  }
`;
